// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1518":"4c28caa534500df1","4301":"d782499f3f797a00","5428":"4c2881c5c906e7db","9812":"abaebdf2fd87b7ce"}[chunkId] + ".js";
};